import styled from "styled-components";
import { FONT_WT_REGULAR } from "@website-builder/utilities-index";

export const ContactUsWrapper = styled.section`
	text-align: center;
	h2 {
		font-size: 18px;
	}
	.rich-text {
		font-size: 20px;
		font-weight: ${FONT_WT_REGULAR};
		a {
			color: inherit;
			text-decoration: none;
		}
	}
`;
